import React, { Component } from "react";
import { Col, message, PageHeader, Row, Spin, Tabs, Select } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import {
    ButtonItem,
    Form,
    InputNumberItem,
    SelectItem,
    FormItem,
    InputItem
} from "../../../Components/Items";

const { TabPane } = Tabs;
const { Option } = Select;

class ConfiguracionAsistencia extends Component {
    formRef = React.createRef();
    state = {
        activeKey: "1",
        configExiste: false,
        loadingInit: true,
        modoDemo: false,
        ventaOnline: false,
    };

    componentDidMount() {
        this.consultarConfiguracion()
    }
    onFinish(values) {
        axios
            .post(
                "configuracionAsistencia/editarConfiguracionAsistencia",
                { ...values, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Se ha modificado la configuracion de asistencia");
                } else if (res.data.success === 1) {
                    message.error("No se pudo modificar la configuracion");
                } else {
                    message.error("Hubo un error y no se modifico la configuracion");
                }
            });
    }
    async consultarConfiguracion() {
        this.setState({ loading: true })
        await axios
            .post(
                "configuracionAsistencia/selectConfiguracionAsistencia",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.formRef.current.setFieldsValue({
                        ...(res.data?.data || {}),
                    });
                } else {
                    message.error("Error no se encontro configuracion de esta empresa");
                }
            });

        this.setState({ loading: false })
    }
    onFinishFailed(e) {
        e.errorFields.map((value, index) => {
            if (e.errorFields[index].name[1]) {
                message.error(
                    "Error: " +
                    e.errorFields[index].errors[0] +
                    " en la fila " +
                    (e.errorFields[index].name[1] + 1)
                );
            } else {
                message.error("Error: Falta un campo");
            }
            return null;
        });
    }

    render() {
        return (
            <>
                <PageHeader
                    title="Configuración Asistencia"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                />
                <div
                    style={{
                        backgroundColor: "white",
                        padding: 20,
                        paddingTop: 5,
                        borderRadius: 6,
                    }}
                >
                    <Form
                        ref={this.formRef}
                        name="configuracionAsistencia"
                        layout
                        bottom={
                            (this.props.permisoAgregarConfiguracionAsistencia || this.props.permisoEditarConfiguracionAsistencia) && (
                                <ButtonItem
                                    type="primary"
                                    htmlType="submit"
                                    style={{ display: "block", margin: "0 0 0 auto" }}
                                >
                                    Editar
                                </ButtonItem>
                            )
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Spin spinning={this.state.loading}>
                            <Tabs defaultActiveKey="1">
                                <TabPane tab="General" key="1" forceRender>
                                    <FormItem
                                        name={"_id"}
                                        hidden
                                    >
                                        <InputItem />
                                    </FormItem>
                                    <FormItem
                                        name="checadaDuplicadaMin"
                                        label="Checada duplicada (min)"
                                        required
                                        margin
                                        initialValue={1}
                                        type="number"
                                        max={1440}
                                    >
                                        <InputNumberItem />
                                    </FormItem>
                                </TabPane>
                                <TabPane tab="Tiempos Extras" key="2" forceRender>
                                    <Row gutter={12}>
                                        <Col span={12}>
                                            <FormItem name="tiempoExtra" label="Tiempo extra" margin required initialValue={1}>
                                                <SelectItem placeholder="Tiempo extra">
                                                    <Option value={1}>Ignorar</Option>
                                                    <Option value={2}>Dependiendo del tipo de trabajo</Option>
                                                    <Option value={3}>Dependiendo del tiempo extra</Option>
                                                </SelectItem>
                                            </FormItem>
                                        </Col>

                                        <FormItem shouldUpdate noStyle>
                                            {({ getFieldValue }) =>
                                                getFieldValue("tiempoExtra") !== 1 ? (
                                                    <>

                                                        <Col span={12}>
                                                            <FormItem
                                                                name="tiempoExtraNivel1Horas"
                                                                label="Nivel 1 (horas)"
                                                                margin
                                                                type="number"
                                                                max={24}
                                                                initialValue={0}
                                                            >
                                                                <InputNumberItem />
                                                            </FormItem>
                                                        </Col>

                                                        <Col span={12}>
                                                            <FormItem
                                                                name="tiempoExtraNivel2Horas"
                                                                label="Nivel 2 (horas)"
                                                                margin
                                                                type="number"
                                                                max={24}
                                                                initialValue={0}
                                                            >
                                                                <InputNumberItem />
                                                            </FormItem>
                                                        </Col>

                                                        <Col span={12}>
                                                            <FormItem
                                                                name="tiempoExtraNivel3Horas"
                                                                label="Nivel 3 (horas)"
                                                                margin
                                                                type="number"
                                                                max={24}
                                                                initialValue={0}
                                                            >
                                                                <InputNumberItem />
                                                            </FormItem>
                                                        </Col>
                                                    </>
                                                ) : null
                                            }
                                        </FormItem>
                                    </Row>
                                </TabPane>
                                <TabPane tab="Calculo" key="3" forceRender>
                                    <FormItem
                                        name="redondeoHorasMin"
                                        label="Redondeo de horas"
                                        required
                                        margin
                                        initialValue={0}
                                        tooltip="Las horas trabajadas y extra se redondean al incremento mas cercano antes de mostrarse o usarse en nomina"
                                    >
                                        <SelectItem placeholder="Redondeo de horas">
                                            <Option value={0}>Exacto (sin redondeo)</Option>
                                            <Option value={15}>Cada 15 minutos</Option>
                                            <Option value={30}>Cada 30 minutos</Option>
                                            <Option value={60}>Cada hora</Option>
                                        </SelectItem>
                                    </FormItem>
                                    <FormItem
                                        name="retardoComoAusenciaMin"
                                        label="Retardo como ausencia (min)"
                                        required
                                        margin
                                        initialValue={480}
                                        tooltip="Si un empleado llega tarde más de este tiempo, se considerará como ausencia"
                                        type="number"
                                        max={1440}
                                    >
                                        <InputNumberItem />
                                    </FormItem>
                                    <FormItem
                                        name="salidaTempranaComoAusenciaMin"
                                        label="Salida temprana como ausencia (min)"
                                        required
                                        margin
                                        initialValue={480}
                                        tooltip="Si un empleado sale temprano más de este tiempo, se considerará como ausencia"
                                        type="number"
                                        max={1440}
                                    >
                                        <InputNumberItem />
                                    </FormItem>

                                    <FormItem name="sinChecadaEntrada" label="Sin entrada, contar como" margin required initialValue={2}>
                                        <SelectItem placeholder="Tiempo extra">
                                            <Option value={1}>Llegada Tarde</Option>
                                            <Option value={2}>Ausencia</Option>
                                            <Option value={3}>Incompleto</Option>
                                        </SelectItem>
                                    </FormItem>

                                    <FormItem shouldUpdate noStyle>
                                        {({ getFieldValue }) =>
                                            getFieldValue("sinChecadaEntrada") === 1 ? (
                                                <FormItem
                                                    name="sinChecadaEntradaMin"
                                                    label="Sin checada entrada (min)"
                                                    required
                                                    margin
                                                    initialValue={1}
                                                    type="number"
                                                    max={1440}
                                                >
                                                    <InputNumberItem />
                                                </FormItem>
                                            ) : null
                                        }
                                    </FormItem>

                                    <FormItem
                                        name="sinChecadaSalida"
                                        label="Sin salida, contar como"
                                        margin
                                        required
                                        initialValue={3}
                                    >
                                        <SelectItem placeholder="Tiempo extra">
                                            <Option value={1}>Salida Temprana</Option>
                                            <Option value={2}>Ausencia</Option>
                                            <Option value={3}>Incompleto</Option>
                                        </SelectItem>
                                    </FormItem>

                                    <FormItem shouldUpdate noStyle>
                                        {({ getFieldValue }) =>
                                            getFieldValue("sinChecadaSalida") === 1 ? (
                                                <FormItem
                                                    name="sinChecadaSalidaMin"
                                                    label="Sin checada salida (min)"
                                                    required
                                                    margin
                                                    initialValue={1}
                                                    type="number"
                                                    max={1440}
                                                >
                                                    <InputNumberItem />
                                                </FormItem>
                                            ) : null
                                        }
                                    </FormItem>


                                </TabPane>
                                <TabPane tab="Estados" key="4" forceRender>
                                    <Row>
                                        <Col span={12}>
                                            <FormItem
                                                name="entradaEstado"
                                                label="Entrada"
                                                required
                                                margin
                                                initialValue={0}
                                                type="number"
                                                max={1440}
                                            >
                                                <InputNumberItem />
                                            </FormItem>
                                            <FormItem
                                                name="inicioDescansoEstado"
                                                label="Inicio descanso"
                                                required
                                                margin
                                                initialValue={2}
                                                type="number"
                                                max={1440}
                                            >
                                                <InputNumberItem />
                                            </FormItem>
                                            <FormItem
                                                name="inicioTiempoExtraEstado"
                                                label="Inicio tiempo extra"
                                                required
                                                margin
                                                initialValue={4}
                                                type="number"
                                                max={1440}
                                            >
                                                <InputNumberItem />
                                            </FormItem>
                                        </Col>
                                        <Col span={12}>
                                            <FormItem
                                                name="salidaEstado"
                                                label="Salida"
                                                required
                                                margin
                                                initialValue={1}
                                                type="number"
                                                max={1440}
                                            >
                                                <InputNumberItem />
                                            </FormItem>
                                            <FormItem
                                                name="finDescansoEstado"
                                                label="Fin descanso"
                                                required
                                                margin
                                                initialValue={3}
                                                type="number"
                                                max={1440}
                                            >
                                                <InputNumberItem />
                                            </FormItem>
                                            <FormItem
                                                name="finTiempoExtraEstado"
                                                label="Fin tiempo extra"
                                                required
                                                margin
                                                initialValue={5}
                                                type="number"
                                                max={1440}
                                            >
                                                <InputNumberItem />
                                            </FormItem>
                                        </Col>
                                    </Row>

                                </TabPane>
                            </Tabs>
                        </Spin>
                    </Form>
                </div>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    empresaId: state.empresa.id,
    headersToken: state.user.headersToken,
    permisoAccesoEcommerce:
        state.user.tipo === 0 ||
        state.user.permisos.find(
            (valueTodos) =>
                valueTodos.permisoId.toString() === "697e2c2db47586150a762dc9",
        )?.activado,
    permisoAgregarConfiguracionAsistencia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f022d27899dda241377d16")?.activado,
    permisoEditarConfiguracionAsistencia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f022db7899dda241377d1b")?.activado,
    permisoDeshabilitarConfiguracionAsistencia: state.user.tipo === 0 || state.user.permisos.find(valueTodos => valueTodos.permisoId.toString() === "69f022e87899dda241377d1c")?.activado,
});

export default connect(mapStateToProps)(ConfiguracionAsistencia);
